import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-prof-services',
  templateUrl: './prof-services.component.html',
  styleUrls: ['./prof-services.component.scss']
})
export class ProfServicesComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
